import {
  Clock,
  Smartphone,
  AlertCircle,
  Youtube,
  Instagram,
} from 'lucide-react';
import './OrderInfo.scss';

const OrderInfo = () => {
  // Check if current time is within ordering hours (5PM-11PM)
  const now = new Date();
  const currentHour = now.getHours();
  const isOpen = currentHour >= 17 && currentHour < 23;

  return (
    <section id="order" className="order-info">
      <div className="container">
        <div className="order-info-content">
          <div className="order-status">
            <div className="status-indicator">
              {isOpen ? (
                <>
                  <div className="status-dot open"></div>
                  <span className="status-text">
                    Currently Open for Online Ordering
                  </span>
                </>
              ) : (
                <>
                  <div className="status-dot closed"></div>
                  <span className="status-text">
                    Currently Closed for Online Ordering
                  </span>
                </>
              )}
            </div>
          </div>

          <div className="order-details">
            <div className="order-detail-item">
              <Clock className="order-icon" />
              <div className="order-detail-content">
                <h3>Ordering Hours</h3>
                <p>5:00 PM - 11:00 PM</p>
                <p className="order-note">Daily</p>
              </div>
            </div>

            <div className="order-detail-item">
              <Smartphone className="order-icon" />
              <div className="order-detail-content">
                <h3>Order via Mobile App</h3>
                <p>Download our app for the best ordering experience</p>
                <button className="btn btn-primary app-download-btn">
                  Download App
                </button>
              </div>
            </div>

            <div className="order-detail-item">
              <AlertCircle className="order-icon" />
              <div className="order-detail-content">
                <h3>Live Tracking</h3>
                <p className="order-note">Live tracking not available</p>
                <p>Orders will be delivered within 30-45 minutes</p>
              </div>
            </div>
          </div>

          <div className="social-media-section">
            <h3 className="social-title">Follow Us on Social Media</h3>
            <div className="social-media-buttons">
              <a
                href="https://www.youtube.com/@zfit-in"
                target="_blank"
                rel="noopener noreferrer"
                className="social-media-btn youtube-btn"
              >
                <Youtube className="social-media-icon" />
                <div className="social-media-info">
                  <span className="social-media-name">YouTube</span>
                  <span className="social-media-handle">@zfit-in</span>
                </div>
              </a>

              <a
                href="https://www.instagram.com/zfit_in/"
                target="_blank"
                rel="noopener noreferrer"
                className="social-media-btn instagram-btn"
              >
                <Instagram className="social-media-icon" />
                <div className="social-media-info">
                  <span className="social-media-name">Instagram</span>
                  <span className="social-media-handle">@zfit_in</span>
                </div>
              </a>
            </div>
          </div>

          <div className="delivery-illustration">
            <img
              src="/delivering.png"
              alt="Food delivery illustration"
              className="delivering-image"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default OrderInfo;
